/* istanbul ignore file */
import * as React from "react";
import { store } from "../../../../data";
import { observe } from "mobx";
import { tickerDefaultConfig } from "./TickerDefaultConfig";
export class Ticker extends React.PureComponent {
    constructor(props) {
        super(props);
        this.fillTextLength = 0;
        this.currencySymbol = "";
        this.padLeftPx = 10;
        this.currencySymbol = store.getCurrencySymbol(this.props.jackpot.currencyId);
        this.config = Object.assign(Object.assign({}, tickerDefaultConfig), (props.tickerConfig || {}));
        this.setCanvasContext = this.setCanvasContext.bind(this);
        this.updateCanvasWidth = this.updateCanvasWidth.bind(this);
        observe(this.props.jackpot, "tickerValue", change => this.tickerUpdateListenerFn.bind(this)(change.newValue));
    }
    tickerUpdateListenerFn(newValue) {
        if (!this.ctx || !this.cnvs) {
            return;
        }
        let fillText = `${this.currencySymbol} ${newValue.toFixed(2)}`;
        this.ctx.clearRect(0, 0, this.cnvs.width, this.config.height);
        this.updateCanvasWidth(fillText);
        this.ctx.fillText(fillText, this.padLeftPx, this.config.height / 2);
    }
    updateCanvasWidth(fillText) {
        if (!this.cnvs) {
            return;
        }
        let currentFillText = fillText.length;
        if (currentFillText === this.fillTextLength) {
            return;
        }
        this.fillTextLength = currentFillText;
        this.cnvs.width = this.fillTextLength * this.config.pxPerSymbol + this.padLeftPx;
        this.setCanvasConfig();
    }
    setCanvasConfig() {
        if (!this.ctx) {
            return;
        }
        this.ctx.font = this.config.font;
        this.ctx.fillStyle = this.config.fillStyle;
        this.ctx.shadowOffsetX = this.config.shadowOffsetX;
        this.ctx.shadowOffsetY = this.config.shadowOffsetY;
        this.ctx.shadowBlur = this.config.shadowBlur;
        this.ctx.shadowColor = this.config.shadowColor;
        this.config.textBaseline && (this.ctx.textBaseline = this.config.textBaseline);
        this.ctx.textAlign = this.config.textAlign;
    }
    setCanvasContext(canvas) {
        !this.cnvs && (this.cnvs = canvas);
        !this.ctx && (this.ctx = canvas && canvas.getContext("2d"));
        this.setCanvasConfig();
    }
    render() {
        return React.createElement("canvas", { ref: this.setCanvasContext, height: this.config.height, className: "rj-jackpot__canvas-ticker" });
    }
}
//# sourceMappingURL=Ticker.js.map